<template>
  <div class="container">
    <div class="home_title">快捷方式</div>
    <div class="home_jump">
      <div class="jump_box" @click="jump(1)">
        <div class="img_box">
          <img src="../../../static/images/daishenhe.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.daiShenHe }}</div>
          <div class="state">待审核</div>
        </div>
      </div>

      <div class="jump_box" @click="jump(2)">
        <div class="img_box">
          <img src="../../../static/images/daizhipai.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.daiZhiPai }}</div>
          <div class="state">待指派</div>
        </div>
      </div>

      <div class="jump_box" @click="jump(3)">
        <div class="img_box">
          <img src="../../../static/images/paigeiwo.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.paiGeiWo }}</div>
          <div class="state">派给我</div>
        </div>
      </div>

      <div class="jump_box" @click="jump(4)">
        <div class="img_box">
          <img src="../../../static/images/wofanhuan.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.woFanHuan }}</div>
          <div class="state">我返还</div>
        </div>
      </div>

      <div class="jump_box" @click="jump(5)">
        <div class="img_box">
          <img src="../../../static/images/weixiuzhong.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.weiXiuZhong }}</div>
          <div class="state">维修中</div>
        </div>
      </div>

      <div class="jump_box" @click="jump(7)">
        <div class="img_box">
          <img src="../../../static/images/daiqueren.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.daiQueRen }}</div>
          <div class="state">待确认</div>
        </div>
      </div>

      <div class="jump_box" @click="jump(6)">
        <div class="img_box">
          <img src="../../../static/images/yiwancheng.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.yiWanChen }}</div>
          <div class="state">已完成</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      tableData: [],
      tableParams: {
        carColor: null,
        carNumber: "",
        carService: null,
        companyId: null,
        isIndex: true,
        limit: 10,
        page: 1,
        planType: null,
      },
      OrderNumData: {},
    };
  },
  components: {},
  props: {},
  created() {
    this.getOrderNum();
  },
  methods: {
    getOrderNum() {
      this.$http.queryWorkOrderCount().then((res) => {
        if (res.code === 0) {
          this.OrderNumData = res.data;
        } else {
          this.OrderNumData = {};
          this.$message.error(res.msg);
        }
      });
    },
    jump(index) {
      switch (index) {
        case 1:
          this.$router.push({ path: "/workOrder_Audit" });
          break;
        case 2:
          this.$router.push({ path: "/workOrder_Audit?yishnehe" });
          break;
        case 3:
          this.$router.push({ path: "/workOrder_Admin" });
          break;
        case 4:
          this.$router.push({ path: "/workOrder_Admin" });
          break;
        case 5:
          this.$router.push({ path: "/workOrder_Admin" });
          break;
        case 6:
          this.$router.push({ path: "/workOrder_Admin" });
          break;
        case 7:
          this.$router.push({ path: "/workOrder_Admin" });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue